import { handleActions } from 'redux-actions';

const defaultState = {};

export default handleActions(
  {},

  defaultState
);
